import React from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'

import Modal from '../../../UniformComponents/Modal'
import ModalFooter from '../../../UniformComponents/ModalFooter'
import Typography from '../../../UniformComponents/Typography'
import Button from '../../../UniformComponents/Button'
import Select from '../../form/Select'
import Input from '../../form/Input'
import Checkbox from '../../form/Checkbox'

const InheritedChartModal = ({ store }) => (
    <Modal
        show={store.inheritedSettingsModalVisible}
        onClose={store.handleCloseInheritedSettingsModal}
    >
        <Typography type="h3">Inherited slide settings</Typography>

        <br />

        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 20, width: '45%' }}>
                <Select
                    label="Parent question"
                    showDisabled
                    options={[...store.questions.map((q) => ({
                        value: q.question.id, label: store.getTitle(q.question),
                    })), { value: '', label: 'Please select a child question' }]}
                    value={{
                        value: store.inheritedParentQuestion?.question?.id ?? '',
                        label: store.getTitle(store.inheritedParentQuestion?.question)
                            ?? 'Please select a child question',
                    }}
                />

                <Select
                    label="Select child question"
                    options={store.inheritedChildQuestions
                        .map((q) => ({ value: q.question.id, label: store.getTitle(q.question) }))}
                    onBlur={store.handleSelectInheritedChild}
                    defaultValue={store.inheritedChartModalSelections.child}
                />
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 20, width: '45%' }}>
                <Select
                    label={i18n.t('powerpoint.chart.sorting')}
                    name="ranking"
                    options={store.chartFilterOptions}
                    onBlur={store.updateInheritedSettings}
                    defaultValue={store.inheritedChartModalSelections.ranking}
                />

                <Input
                    type="number"
                    label="Remove base sizes under"
                    name="base"
                    defaultValue={store.inheritedChartModalSelections.base}
                    onBlur={store.updateInheritedSettings}
                />

                <Checkbox
                    label={i18n.t('powerpoint.chart.zero')}
                    name="removeZero"
                    onBlur={store.updateInheritedSettings}
                    checked={store.inheritedChartModalSelections.removeZero}
                />
            </div>

        </div>

        <ModalFooter>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Button
                    label="Cancel"
                    onClick={store.handleCloseInheritedSettingsModal}
                    cssClass="regular tertiary"
                />

                <Button
                    label="Save"
                    icon="fal fa-save"
                    onClick={store.handleAddInheritedSlide}
                    cssClass="regular primary"
                />
            </div>
        </ModalFooter>
    </Modal>
)

export default observer(InheritedChartModal)
